let $ = jQuery;

import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

let AnimationManager = require('../utilities/animation-manager');

let idInnovation = '#innovation';

class HomepageInnovation extends AnimationManager {

  constructor() {
    super();
    this.idKeepExploring = '#homepage-innovation-keep-exploring';
    this.$homepageInnovation = $(idInnovation);
    this.$homepageInnovationContent = this.$homepageInnovation.find('.homepage-innovation__content');
    this.$keepExploring = $(this.idKeepExploring);
  }

  createScenes() {

    let duration = 150;
    let bottom = 150;

    let sceneBackgroundSciencePin = new ScrollMagic.Scene({
        triggerElement: '#homepage-innovation-subheadline',
        offset: '0px',
        duration: duration
      })
      .setTween(this.idKeepExploring, {
        bottom: bottom * -1,
        ease: Power1.easeInOut
      }) // trigger a TweenMax.to tween
      // .addIndicators({name: `${this.idKeepExploring} (duration: ${duration})`}) // add indicators (requires plugin)
      .addTo(this.controller);

  }

  destroyScenes() {
    super.destroyScenes();
    $(this.idKeepExploring).removeAttr('style');
  }

}

function init() {
  if($(idInnovation).length) {
    let homepageInnovation = new HomepageInnovation();
  }
}

if(typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

} else {

  // Export for Drupal
  module.exports = {
    attach: function (context, settings) {
      init();
    }
  };

}
